( function( global, factory ) {

	"use strict";
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "LeapBridge requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	var LeapBridge = {};
	LeapBridge.sendToHost=function(value){
		if(!window.ipcRenderer){
			return;
		}
		window.ipcRenderer.sendToHost(value)
	};
	
	if ( !noGlobal ) {
		window.LeapBridge= LeapBridge;
	}
	return LeapBridge;
});


// WEBPACK FOOTER //
// ./src/libs/LeapBridge.js